import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-0"}]]

/**
 * IconCrop75Filled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY3JvcC03LTUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDVhMyAzIDAgMCAxIDMgM3Y4YTMgMyAwIDAgMSAtMyAzaC0xMmEzIDMgMCAwIDEgLTMgLTN2LThhMyAzIDAgMCAxIDMgLTN6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/crop-7-5-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCrop75Filled = createReactComponent('filled', 'crop-7-5-filled', 'Crop75Filled', __iconNode);

export default IconCrop75Filled;